import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
// Components
import Product from "../Product/Product"
import Grid from "../Grid/Grid"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import { Container } from "./Products.styles"
import { useTheme } from "styled-components"

const Products = ({ category, filters, sort, search, endingPoint }) => {
   const location = useLocation()
   const theme = useTheme()
   const isProducts = location.pathname.split("/")[1] === "products"
   const [products, setProducts] = useState([])
   const [filteredProducts, setFilteredProducts] = useState([])
   const [isFiltered, setIsFiltered] = useState(false)
   const [isMainColor, setIsMainColor] = useState(false)
   const [isSecondColor, setIsSecondColor] = useState(false)

   useEffect(() => {
      const getProducts = async () => {
         try {
            const res = await publicRequest.get(
               category
                  ? `products/collection?category=${category}`
                  : `products/collection`,
            )
            const productsFromCall = res.data.sort(
               (a, b) => a.ranking - b.ranking,
            )

            setProducts(productsFromCall)
         } catch (err) {
            setProducts(err)
         }
      }
      getProducts()
   }, [category])

   useEffect(() => {
      !category && setFilteredProducts(products)

      let productsFiltered = products
      let productsAndColors = []
      let mainColor
      filters ? (mainColor = filters.mainColor) : (mainColor = null)
      let secondColor
      filters ? (secondColor = filters.secondColor) : (secondColor = null)

      const filterProducts = () => {
         Object.entries(filters).forEach(([key, value]) => {
            if (value !== "all" && products.length > 0) {
               productsFiltered = productsFiltered.filter((item) =>
                  key === "mainColor"
                     ? item.variations.some(
                          ({ mainColor }) => mainColor === value,
                       )
                     : key === "secondColor"
                       ? item.variations.some(
                            ({ secondColor }) => secondColor === value,
                         )
                       : item[key].includes(value),
               )
            }
         })
         setIsFiltered(true)
      }

      const getMainColors = async () => {
         let productsBicolors = []

         if (isSecondColor && secondColor !== "all") {
            for (let i = 0; i < productsFiltered.length; i++) {
               const variations = productsFiltered[i].variations
               let imgColor = ""
               if (theme.name === "dark") {
                  imgColor = variations.find(
                     (item) => item.secondColor === secondColor,
                  ).imagesDark[0]
               } else {
                  imgColor = variations.find(
                     (item) => item.secondColor === secondColor,
                  ).imagesLight[0]
               }
               const idColor = variations.find(
                  (item) => item.secondColor === secondColor,
               )._id
               const variationMainColor = variations.find(
                  (item) => item.secondColor === secondColor,
               ).mainColor

               if (variationMainColor === mainColor) {
                  productsBicolors.push({
                     ...productsFiltered[i],
                     imgColor,
                     idColor,
                  })
               }
            }
            setFilteredProducts(productsBicolors)
         } else {
            for (let i = 0; i < productsFiltered.length; i++) {
               const variations = productsFiltered[i].variations
               let imgColor = ""
               if (theme.name === "dark") {
                  imgColor = variations.find(
                     (item) => item.mainColor === mainColor,
                  ).imagesDark[0]
               } else {
                  imgColor = variations.find(
                     (item) => item.mainColor === mainColor,
                  ).imagesLight[0]
               }
               let idColor = variations.find(
                  (item) => item.mainColor === mainColor,
               )._id

               productsAndColors.push({
                  ...productsFiltered[i],
                  imgColor,
                  idColor,
               })
            }
            setFilteredProducts(productsAndColors)
         }
         mainColor !== "all" && setIsMainColor(true)
      }

      const getSecondColors = async () => {
         let productsBicolors = []

         if (isMainColor && mainColor !== "all") {
            for (let i = 0; i < productsFiltered.length; i++) {
               const variations = productsFiltered[i].variations
               let imgColor = ""
               if (theme.name === "dark") {
                  imgColor = variations.find(
                     (item) => item.mainColor === mainColor,
                  ).imagesDark[0]
               } else {
                  imgColor = variations.find(
                     (item) => item.mainColor === mainColor,
                  ).imagesLight[0]
               }
               const idColor = variations.find(
                  (item) => item.mainColor === mainColor,
               )._id
               const variationSecondColor = variations.find(
                  (item) => item.mainColor === mainColor,
               ).secondColor

               if (variationSecondColor === secondColor) {
                  productsBicolors.push({
                     ...productsFiltered[i],
                     imgColor,
                     idColor,
                  })
               }
            }
            setFilteredProducts(productsBicolors)
         } else {
            for (let i = 0; i < productsFiltered.length; i++) {
               const variations = productsFiltered[i].variations
               let imgColor = ""
               if (theme.name === "dark") {
                  imgColor = variations.find(
                     (item) => item.secondColor === secondColor,
                  ).imagesDark[0]
               } else {
                  imgColor = variations.find(
                     (item) => item.secondColor === secondColor,
                  ).imagesLight[0]
               }
               const idColor = variations.find(
                  (item) => item.secondColor === secondColor,
               )._id

               productsAndColors.push({
                  ...productsFiltered[i],
                  imgColor,
                  idColor,
               })
            }
            setFilteredProducts(productsAndColors)
         }
         secondColor !== "all" && setIsSecondColor(true)
      }

      isProducts && filterProducts()

      if (mainColor && mainColor !== "all") {
         getMainColors()
         if (secondColor && secondColor !== "all") {
            getSecondColors()
         }
      } else if (secondColor && secondColor !== "all") {
         getSecondColors()
      } else {
         setFilteredProducts(productsFiltered)
      }
   }, [
      isProducts,
      isMainColor,
      isSecondColor,
      products,
      category,
      filters,
      theme,
   ])

   useEffect(() => {
      if (products.length > 0) {
         if (category) {
            if (sort === "latest") {
               setFilteredProducts((prev) =>
                  [...prev].sort(
                     (a, b) =>
                        Number(b.latest) - Number(a.latest) ||
                        a.ranking - b.ranking,
                  ),
               )
            } else if (sort === "name") {
               setFilteredProducts((prev) =>
                  [...prev].sort((a, b) => a.title.localeCompare(b.title)),
               )
            } else if (sort === "asc") {
               setFilteredProducts((prev) =>
                  [...prev].sort(
                     (a, b) => a.prices[0].price - b.prices[0].price,
                  ),
               )
            } else if (sort === "desc") {
               setFilteredProducts((prev) =>
                  [...prev].sort(
                     (a, b) => b.prices[0].price - a.prices[0].price,
                  ),
               )
            } else if (sort === "sales") {
               setFilteredProducts((prev) =>
                  [...prev].sort((a, b) => a.ranking - b.ranking),
               )
            }
         } else {
            if (sort === "latest") {
               setProducts((prev) =>
                  [...prev].sort(
                     (a, b) =>
                        Number(b.latest) - Number(a.latest) ||
                        a.ranking - b.ranking,
                  ),
               )
            } else if (sort === "name") {
               setProducts((prev) =>
                  [...prev].sort((a, b) => a.title.localeCompare(b.title)),
               )
            } else if (sort === "asc") {
               setProducts((prev) =>
                  [...prev].sort(
                     (a, b) => a.prices[0].price - b.prices[0].price,
                  ),
               )
            } else if (sort === "desc") {
               setProducts((prev) =>
                  [...prev].sort(
                     (a, b) => b.prices[0].price - a.prices[0].price,
                  ),
               )
            } else if (sort === "sales") {
               setProducts((prev) =>
                  [...prev].sort((a, b) => a.ranking - b.ranking),
               )
            }
         }
      }
   }, [category, sort, products.length])

   useEffect(() => {
      if (!isProducts && search) {
         const filtered = products.filter((item) =>
            item.title.includes(search.toUpperCase()),
         )
         let results = []

         for (let i = 0; i < products.length; i++) {
            const idColor = products[i].variations.find((item) =>
               item.code.includes(search.toUpperCase()),
            )?._id
            let imgColor = ""
            if (theme.name === "dark") {
               imgColor = products[i].variations.find((item) =>
                  item.code.includes(search.toUpperCase()),
               )?.imagesDark[0]
            } else {
               imgColor = products[i].variations.find((item) =>
                  item.code.includes(search.toUpperCase()),
               )?.imagesLight[0]
            }
            idColor && results.push({ ...products[i], idColor, imgColor })
         }
         results.length > 0
            ? setFilteredProducts(results)
            : setFilteredProducts(filtered)

         setIsFiltered(true)
      }
   }, [products, isProducts, search, theme])

   return (
      <Container>
         <Grid>
            {isFiltered
               ? filteredProducts.length > 0 &&
                 filteredProducts.map((item, index) => (
                    <Product
                       product={item}
                       key={item._id}
                       endingPoint={endingPoint}
                       index={index}
                    />
                 ))
               : products.length > 0 &&
                 products
                    .slice(0, 8)
                    .map((item, index) => (
                       <Product
                          product={item}
                          key={item._id}
                          endingPoint={endingPoint}
                          index={index}
                       />
                    ))}
         </Grid>
      </Container>
   )
}

Products.propTypes = {
   category: PropTypes.string,
   filters: PropTypes.object,
   sort: PropTypes.string,
   search: PropTypes.string,
   endingPoint: PropTypes.object,
}

export default Products
